<template>
  <div class="Home">
    <!-- 轮播图开始 -->
    <div class="part1">
      <!-- banner -->
      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <!-- logo -->
            <img :style="{'width': 253*scaleBiLi + 'px', 'height': 52*scaleBiLi + 'px' ,'top':  + 36*scaleBiLi + 'px','left':  + 60*scaleBiLi + 'px'}" style="position: absolute;left: 60px;top: 36px;z-index: 99" src="@/assets/images/Home01@2x.png" alt="">
            <!-- 最大背景 -->
            <img style="max-width: 100%;" src="@/assets/images/Home02@2x.png" alt="">
            <img class="animation3 anim3" style="max-width:100%;width: 62.7%;position: absolute;left: -16.7%;top: 11.2%;" src="@/assets/images/Home03@2x.png" alt="">
            <img class="animation4 anim4" style="max-width:100%;width: 34.82%;position: absolute;right: -11.4%;top: 0px;z-index: 9" src="@/assets/images/Home04@2x.png" alt="">
            <img class="animation2 anim2" style="max-width:100%;width: 78%;height:100%;position: absolute;right: 0;top: 0;z-index: 10" src="@/assets/images/Home05@2x.png" alt="">
            <img class="animation1 anim1" v-if="$store.getters.lang=='zh'" style="max-width:100%;width: 36.4%;position: absolute;left: 0;top: 56.4%;z-index: 11" src="@/assets/images/Home06@2x.png" alt="">
            <img class="animation1en anim1en" v-else style="max-width:100%;width: 37%;position: absolute;left: 0;top: 65%;z-index: 11" src="@/assets/images/Home06en@2x.png" alt="">
            <div @click="toOpenMP4" class="video animation5 anim5" :style="{'width': 362*scaleBiLi + 'px', 'height': 182*scaleBiLi + 'px' ,'bottom':  + 242*scaleBiLi + 'px','right':  + 84*scaleBiLi + 'px'}">
              <div style="position: relative;width: 100%;">
                <img style="width: 100%;" src="@/assets/images/Home07@2x.png" alt="">
                <!--<img class="playerBtn" src="@/assets/images/Home08@2x.png" alt="">-->
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <!-- logo -->
            <img :style="{'width': 253*scaleBiLi + 'px', 'height': 52*scaleBiLi + 'px' ,'top':  + 36*scaleBiLi + 'px','left':  + 60*scaleBiLi + 'px'}" style="position: absolute;left: 60px;top: 36px;z-index: 99" src="@/assets/images/Home01@2x.png" alt="">
            <!-- 最大背景 -->
            <img style="max-width: 100%;" src="@/assets/images/Home02@2x.png" alt="">
            <img class="animation3 anim3" style="max-width:100%;width: 62.7%;position: absolute;left: -16.7%;top: 11.2%;" src="@/assets/images/Home03@2x.png" alt="">
            <img class="animation4 anim4" style="max-width:100%;width: 34.82%;position: absolute;right: -11.4%;top: 0px;z-index: 9" src="@/assets/images/Home04@2x.png" alt="">
            <img class="animation2 anim2" style="max-width:100%;width: 78%;height:100%;position: absolute;right: 0;top: 0;z-index: 10" src="@/assets/images/Home05_1@2x.png" alt="">
            <img class="animation1 anim1" v-if="$store.getters.lang=='zh'" style="max-width:100%;width: 36.4%;position: absolute;left: 0;top: 56.4%;z-index: 11" src="@/assets/images/Home06@2x.png" alt="">
            <img class="animation1en anim1en" v-else style="max-width:100%;width: 37%;position: absolute;left: 0;top: 65%;z-index: 11" src="@/assets/images/Home06en@2x.png" alt="">
            <div @click="toOpenMP4" class="video animation5 anim5" :style="{'width': 362*scaleBiLi + 'px', 'height': 182*scaleBiLi + 'px' ,'bottom':  + 242*scaleBiLi + 'px','right':  + 84*scaleBiLi + 'px'}">
              <div style="position: relative;width: 100%;">
                <img style="width: 100%;" src="@/assets/images/Home07@2x.png" alt="">
                <!--<img class="playerBtn" src="@/assets/images/Home08@2x.png" alt="">-->
              </div>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="mySwiper-pagination">
          <div>01</div>
          <div class="middle">
            <div class="swiper-pagination"></div>
          </div>
          <div>02</div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="mySwiper-button">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <!-- 顶部右侧操作按钮 -->
      <div class="switchBtn" :style="{'top':45*scaleBiLi+'px','right':60*scaleBiLi+'px','transform': 'scale(' + scaleBiLi + ')','transform-origin': 'right top'}">
        <div class="item">
          <el-popover
            placement="bottom"
            width="190"
            trigger="click">
            <input v-model="keyword" @keydown.enter="toKeyDownEnter" type="text" :placeholder="$t('homeHeader.keyword')" class="cp-list-search-input">
            <img src="@/assets/images/Home09@2x.png" slot="reference" alt="">
          </el-popover>
        </div>
        <i></i>
        <div v-if="$store.getters.lang=='zh'" class="item" @click="toChangeLang('en')">
          <img src="@/assets/images/Home10@2x.png" alt="">
        </div>
        <div v-else-if="$store.getters.lang=='en'" class="item" @click="toChangeLang('zh')">
          <img src="@/assets/images/Home10_2@2x.png" alt="">
        </div>
        <!--<div class="item">-->
          <!--<img src="@/assets/images/Home11@2x.png" alt="">-->
        <!--</div>-->
      </div>
      <!-- nav导航 -->
      <div class="navigation" :style="{'width': 1920*scaleBiLi + 'px','height':  152*scaleBiLi + 'px'}">
        <div class="navigation-cover" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left center'}">
          <router-link v-if="item.url !='/Search' && $store.getters.lang == 'zh' && !item.hidden" v-for="(item,index) in $store.getters.menu" :key="index" class="item" :class="index==0?'active':''" tag="div" :to="item.url">{{item.title}}</router-link>
          <router-link v-if="item.url !='/Search' && $store.getters.lang == 'en' && !item.hidden" v-for="(item,index) in $store.getters.menuEn" :key="index" class="item" :class="index==0?'active':''" tag="div" :to="item.url">{{item.title}}</router-link>
        </div>
      </div>
    </div>
    <!-- 轮播图结束 -->

    <!-- 服务部分开始 -->
    <div class="part2" :style="{'width': 1920*scaleBiLi + 'px','height':  631*scaleBiLi + 'px'}">
      <div class="main" :style="{'transform': 'scale(' + scaleBiLi + ')'}">
        <div class="item item1">
          <img class="p1" src="@/assets/images/Home15@2x.png" alt="">
          <div class="p2">{{$t('homeBody.p1')}}</div>
          <div class="p3" :style="{'font-size' : $store.getters.lang=='en'?'16px':''}">{{$t('homeBody.p2')}}：09：00<br/>{{$t('homeBody.p3')}}：16：30<br/>{{$t('homeBody.p4')}}：17：00</div>
          <div class="p4" :style="{'font-size' : $store.getters.lang=='en'?'14px':'','margin-top' : $store.getters.lang=='en'?'10px':''}">{{$t('homeBody.p5')}}</div>
        </div>
        <div class="item item2">
          <img class="p1" src="@/assets/images/Home17@2x.png" alt="">
          <div class="p2">{{$t('homeBody.p6')}}</div>
          <div class="p3">
            <div class="p3-item" @click="toTanWeiXin">{{$t('homeBody.p7')}}</div>
            <div class="p3-item" @click="toTanGuoWai">{{$t('homeBody.p8')}}</div>
          </div>
          <div class="p4" :style="{'font-size' : $store.getters.lang=='en'?'15px':''}">{{$t('homeBody.p9')}}</div>
        </div>
        <div class="item item3">
          <img class="p1" src="@/assets/images/Home19@2x.png" alt="">
          <div class="p2">{{$t('homeBody.p10')}}</div>
          <div class="p3" :style="{'font-size' : $store.getters.lang=='en'?'14px':'','line-height' : $store.getters.lang=='en'?'26px':''}">
            <div class="p3-item">
              <div class="p3-item-l">{{$t('homeBody.p11')}}：</div>
              <div class="p3-item-r">{{$t('homeBody.p12')}}</div>
            </div>
            <div class="p3-item">
              <div class="p3-item-l">{{$t('homeBody.p13')}}：</div>
              <div class="p3-item-r">{{$t('homeBody.p14')}}</div>
            </div>
            <div class="p3-item">
              <div class="p3-item-l">{{$t('homeBody.p15')}}：</div>
              <div class="p3-item-r">{{$t('homeBody.p16')}}</div>
            </div>
          </div>
        </div>
        <div class="item item4">
          <img class="p1" src="@/assets/images/Home21@2x.png" alt="">
          <div class="p2">{{$t('homeBody.p17')}}</div>
          <div class="p3" :style="{'font-size' : $store.getters.lang=='en'?'14px':''}">
            <div class="p3-item">
              <div class="p3-item-l"></div>
              <div class="p3-item-r">{{$t('homeBody.p18')}}</div>
            </div>
            <div class="p3-item">
              <div class="p3-item-l"></div>
              <div class="p3-item-r">{{$t('homeBody.p19')}}</div>
            </div>
            <div class="p3-item">
              <div class="p3-item-l"></div>
              <div class="p3-item-r">{{$t('homeBody.p20')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务部分结束 -->

    <!-- 举重简介开始 -->
    <div class="part3" :style="{'width': 1920*scaleBiLi + 'px','height':  1119*scaleBiLi + 'px','padding-top':  178*scaleBiLi + 'px','padding-left':  86*scaleBiLi + 'px'}">
      <div class="text" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left top'}">
        <div class="icon"><img src="@/assets/images/Home23@2x.png" alt=""></div>
        <div class="title" :style="{'font-size' : $store.getters.lang=='en'?'33px':''}">{{$t('homeBody.p21')}}</div>
        <div class="summary" :style="{'font-size' : $store.getters.lang=='en'?'20px':'','line-height' : $store.getters.lang=='en'?'37px':''}">
          {{$t('homeBody.p22')}}
        </div>
        <div class="feature">
          <div class="item">
            <img class="themeIcom" src="@/assets/images/Home24@2x.png" alt="">
            <div class="theme">{{$t('homeBody.p23')}}</div>
            <div class="summarize" style="width: 146px;">{{$t('homeBody.p24')}}</div>
          </div>
          <div class="item">
            <img class="themeIcom" src="@/assets/images/Home25@2x.png" alt="">
            <div class="theme">{{$t('homeBody.p25')}}</div>
            <div class="summarize" style="width: 100px;">{{$t('homeBody.p26')}}</div>
          </div>
          <div class="item">
            <img class="themeIcom" src="@/assets/images/Home26@2x.png" alt="">
            <div class="theme">{{$t('homeBody.p27')}}</div>
            <div class="summarize">6000{{$t('homeBody.p28')}}</div>
          </div>
        </div>
        <router-link to="/MuseumAffairsA1" class="more">
          <img v-if="$store.getters.lang=='zh'" src="@/assets/images/Home27@2x.png" alt="">
          <img v-else src="@/assets/images/Home27en@2x.png" alt="">
        </router-link>
      </div>
      <div class="banner" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'right top','top': 180 * scaleBiLi +'px'}">
          <img class="pic01 animation8" src="@/assets/images/Home29@2x.png" alt="">
          <img class="pic02 animation9" src="@/assets/images/Home28@2x.png" alt="">
          <img class="pic03 animation10" src="@/assets/images/Home30@2x.png" alt="">
      </div>
    </div>
    <!-- 举重简介结束 -->

    <!-- 冠军故事开始 -->
    <div class="part4" :style="{'width': 1920*scaleBiLi + 'px','height':  1260*scaleBiLi + 'px','padding-top':  89*scaleBiLi + 'px'}">
      <div class="banner" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left top'}">
        <img class="animation6 img01" v-if="part4Arr.length>0" :src="part4Arr[part4ArrIndex].picLeft" alt="">
        <router-link to="/ExhibitionA4">
          <img v-if="$store.getters.lang=='zh'" class="more animation7" src="@/assets/images/Home32@2x.png" alt="">
          <img v-else class="more animation7" src="@/assets/images/Home32en@2x.png" alt="">
        </router-link>
      </div>
      <div class="text" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'right top','top': 223 * scaleBiLi +'px','right': 262 * scaleBiLi +'px'}">
        <div v-if="part4Arr.length>0" class="name">{{part4Arr[part4ArrIndex].name}}</div>
        <div v-if="part4Arr.length>0" class="title">{{part4Arr[part4ArrIndex].title}}</div>
        <div class="summary" v-if="part4Arr.length>0">
          {{part4Arr[part4ArrIndex].summary}}
        </div>
        <div class="btn">
          <img @click="toPart4Prev" v-if="part4ArrIndex === 0" src="@/assets/images/Home34@2x.png" alt="">
          <img @click="toPart4Prev" v-else src="@/assets/images/Home34_active@2x.png" alt="">
          <img @click="toPart4Next" v-if="part4ArrIndex === part4Arr.length-1" src="@/assets/images/Home35@2x.png" alt="">
          <img @click="toPart4Next" v-else src="@/assets/images/Home35_active@2x.png" alt="">
        </div>
        <div class="pic">
          <div class="picBox">
            <img v-if="part4Arr.length>0" :src="part4Arr[part4ArrIndex].picRight" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 冠军故事结束 -->

    <!-- 展厅介绍开始 -->
    <div class="part5">
      <div class="tab" :style="{'width': 1920*scaleBiLi + 'px','height':  375*scaleBiLi + 'px','padding-top' : 180*scaleBiLi +'px'}">
        <div class="list" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'center top'}">
          <div class="item" v-if="part5Arr.length>0" :class="part5Index == index ?'active' : ''" v-for="(item,index) in part5Arr" @click="toPart5Tab(index)">
            <div class="pic">
              <img :src="item.picUrl" alt="">
            </div>
            <div class="title" :style="{'font-size' : $store.getters.lang=='en'?'16px':''}">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="main" :style="{'width': 1920*scaleBiLi + 'px','height':  1180*scaleBiLi + 'px'}">
        <div class="content" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left top'}">
          <img class="bgLine" src="@/assets/images/Home44@2x.png" alt="">
          <img class="bg" v-if="part5Arr.length>0" :src="part5Arr[part5Index].picLeft" alt="">
          <div class="text">
            <div class="title" v-if="part5Arr.length>0">{{part5Arr[part5Index].title}}</div>
            <div class="summary" v-if="part5Arr.length>0">{{part5Arr[part5Index].summary}}</div>
            <div class="btn">
              <img class="prev" v-if="part5Index === 0" src="@/assets/images/Home46@2x.png" alt="" @click="toPart5Prev">
              <img class="prev" v-else src="@/assets/images/Home46_active@2x.png" alt="" @click="toPart5Prev">
              <img class="next" v-if="part5Index === part5Arr.length-1" src="@/assets/images/Home47@2x.png" alt="" @click="toPart5Next">
              <img class="next" v-else src="@/assets/images/Home47_active@2x.png" alt="" @click="toPart5Next">
            </div>
          </div>
        </div>
        <router-link :to="{path: part5Arr[part5Index]? '/ExhibitionA1Detail/'+part5Arr[part5Index].id : ''}" tag="div" class="banner" :style="{'width': 1069*scaleBiLi + 'px','height':  1073*scaleBiLi + 'px','top':  107*scaleBiLi + 'px'}">
          <div class="pic-cover" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'right top'}">
            <img class="pic01 animation11" v-if="part5Arr.length>0" :src="part5Arr[part5Index].picright" alt="">
            <img class="pic02 animation12" v-if="part5Arr.length>0" :src="part5Arr[part5Index].picright2" alt="">
            <img class="pic04 animation13" v-if="part5Arr.length>0" :src="part5Arr[part5Index].picright3" alt="">
            <img class="pic03 animation14" src="@/assets/images/Home50@2x.png" alt="">
          </div>
        </router-link>
      </div>
    </div>
    <!-- 展厅介绍结束 -->

    <!-- 举博藏品开始 -->
    <div class="part6" :style="{'width': 1920*scaleBiLi + 'px','height':  1326*scaleBiLi + 'px','padding-left':  174*scaleBiLi + 'px','padding-top':  211*scaleBiLi + 'px'}">
      <div class="main" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left top'}">
        <div class="conItem animation15">
          <div class="title">
            {{$t('homeBody.p27')}}
          </div>
          <div class="number">
            <span>{{part6NumBer}}</span>{{$t('homeBody.p28')}}
          </div>
          <div class="list">
            <div class="item" v-if="part6Arr.length>0" :class="index == part6Index?'active':''" v-for="(item,index) in part6Arr" @click="toPart6Tab(index)">
              <img :src="item.icon" alt="">
              <span>{{item.title}}</span>
            </div>
          </div>
        </div>
        <router-link :to="{path:'/CollectionA1Detail/'+item.id}" tag="div" class="conItem" :class="index==0?'animation16':index==1?'animation17':'animation18'" :key="index" v-for="(item,index) in part6Arr[part6Index]? part6Arr[part6Index].listData : []">
          <img :src="item.pic" alt="">
          <img class="img-cover" src="@/assets/images/Home58_active@2x.png" alt="">
          <div style="position: relative;display:none;">
            <div class="item-text">
              {{item.summary}}
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 举博藏品结束 -->

    <!-- 新闻中心开始 -->
    <div class="part7" :style="{'width': 1920*scaleBiLi + 'px','height':  1320*scaleBiLi + 'px'}">
      <div class="main" :style="{'transform': 'scale(' + scaleBiLi + ')','transform-origin': 'left top'}">
        <div class="banner">
          <img src="@/assets/images/Home61@2x.png" class="animation19" alt="">
          <img src="@/assets/images/Home62@2x.png" class="animation20" alt="">
        </div>
        <div class="new">
          <div class="newHot">
            <div class="title">
              {{$t('homeBody.p29')}}
            </div>
            <div class="summary">
              {{ part7Arr[0]?part7Arr[0].title:'' }}
            </div>
            <div class="detail">
              {{ part7Arr[0]?part7Arr[0].summary:'' }}
            </div>
          </div>
          <div class="newList">
            <div class="tab">
              <span @click="toPart7Tab(0)" :class="part7Index == 0 ? 'active':''">{{$t('homeBody.p31')}}</span>
              <span @click="toPart7Tab(1)" :class="part7Index == 1 ? 'active':''">{{$t('homeBody.p32')}}</span>
              <span @click="toPart7Tab(2)" :class="part7Index == 2 ? 'active':''">{{$t('homeBody.p33')}}</span>
            </div>
            <div class="item" v-for="(item,index) in part7Arr">
              <router-link  tag="div" class="list" :to="{path:part7Index==0?('/NewsA1Detail/'+item.id):part7Index==1?('/NewsA1Detail/'+item.id):('/NewsA2Detail/'+item.id)}">
                <div class="pic">
                  <img v-if="item.picUrl != null" :src="item.picUrl" alt="">
                </div>
                <div class="text">
                  <div class="title">
                    {{item.title}}
                  </div>
                  <div class="addTime">
                    {{item.addTime}}
                  </div>
                </div>
              </router-link>
            </div>
            <router-link :to="{path:part7Index==0?'/ExploreA1':part7Index==1?'/NewsA1':'NewsA2'}" class="more"> {{$t('homeBody.p30')}} <img src="@/assets/images/Home64@2x.png" alt=""></router-link>
          </div>
        </div>
      </div>
      <div class="bgLine">
        <img src="@/assets/images/Home65@2x.png" alt="">
      </div>
    </div>
    <!-- 新闻中心结束 -->

    <!-- 底部开始 -->
    <Footer></Footer>
    <!-- 底部结束 -->

    <!--二维码预约-->
    <el-dialog append-to-body :visible.sync="dialogVisible_WeiXin" :lock-scroll="false" width="800px" @close="toHideDialog">
      <div class="tan_weixin">
        <img class="title" v-if="$store.getters.lang == 'en'"  src="@/assets/images/Serve12_2@2x.png" alt="">
        <img class="title" v-else  src="@/assets/images/Serve12@2x.png" alt="">
        <img class="code" src="@/assets/images/Serve13@2x.png" alt="">
      </div>
    </el-dialog>
    <!--国内观众预约-->
    <el-dialog append-to-body :visible.sync="dialogVisible_GuoWai" :lock-scroll="false" width="700px" @close="toHideDialog">
      <div  v-if="!dialogVisible_GuoWai_BookSuccess" class="tan_guowai">
        <img class="title" v-if="$store.getters.lang == 'en'" src="@/assets/images/Serve18_2@2x.png" alt="">
        <img class="title" v-else src="@/assets/images/Serve18@2x.png" alt="">
        <div class="form">
          <el-form ref="form" :model="form" :rules="$store.getters.lang == 'en'?rules2:rules" label-width="100px">
            <!--@keyup.enter.native="handleQuery"-->
            <!--clearable-->
            <el-form-item :label="$t('otherPage.p30')" prop="userName">
              <el-input style="width: 430px;" v-model="form.userName" :placeholder="$t('otherPage.p31')" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p32')" prop="cardType">
              <el-select style="width: 430px;" v-model="form.cardType" :placeholder="$t('otherPage.p33')">
                <el-option :label="$t('otherPage.p34')" :value="$t('otherPage.p34')"></el-option>
                <el-option :label="$t('otherPage.p35')" :value="$t('otherPage.p35')"></el-option>
                <el-option :label="$t('otherPage.p36')" :value="$t('otherPage.p36')"></el-option>
                <el-option :label="$t('otherPage.p37')" :value="$t('otherPage.p37')"></el-option>
                <el-option :label="$t('otherPage.p38')" :value="$t('otherPage.p38')"></el-option>
                <el-option :label="$t('otherPage.p39')" :value="$t('otherPage.p39')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p40')" prop="cardNo">
              <el-input style="width: 430px;" v-model="form.cardNo" :placeholder="$t('otherPage.p41')" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p42')" prop="email">
              <el-input style="width: 430px;" v-model="form.email" :placeholder="$t('otherPage.p43')" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p44')" prop="smsCode">
              <el-input style="width: 310px;" v-model="form.smsCode" :placeholder="$t('otherPage.p45')" maxlength="10"></el-input>
              <div style="width: 100px;float: right;margin-right: 10px;">
                <el-button  type="primary" @click="toGetValidCode" style=" border-color: #DA1E2D; background: #DA1E2D; border-radius: 5px;" >{{$t('otherPage.p46')}}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p47')" prop="bookDate">
              <el-date-picker
                style="width: 430px;"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                v-model="form.bookDate"
                type="date"
                :placeholder="$t('otherPage.p48')">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" type="primary" @click="toSubmit">{{$t('otherPage.p49')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="dialogVisible_GuoWai_BookSuccess"  class="tan_success">
        <img src="https://www.cwmuseum.cn/img/Serve20@2x.png" alt="">
        <img src="https://www.cwmuseum.cn/img/Serve21@2x.png" alt="">
        <div class="summary">{{$t('otherPage.p50')}}</div>
        <div class="btn" @click="toHideDialog">{{$t('otherPage.p49')}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getSingle,listShowRoom,getGoodsTypeVer2,getTokenCode,getEmailValidCode,bookingByEmailValidCode} from "@/api"
  import i18n from "@/i18n" //根据项目对应真实路径
  import Swiper from "swiper";
  import Footer from "@/common/Footer";
  import {mixin} from '@/mixin/index'

  export default {
    name: 'Home',
    mixins:[mixin],
    components : {
      Footer
    },
    data() {
      return {
        // 关键字
        keyword : '',
        // 当前屏幕比例
        scaleBiLi : 1,
        // 轮播图
        swiperSlideArr : [],
        // part4
        part4ArrIndex : 0,
        part4Arr : [],
        // part5
        part5Index : 0,
        part5Arr : [],
        // part6
        part6NumBer :6000,
        part6Index : 0,
        part6Arr : [],
        // part7
        part7Index : 0,
        part7Arr : [],
        // 弹窗
        dialogVisible_GuoWai: false,
        dialogVisible_WeiXin: false,
        dialogVisible_GuoWai_BookSuccess: false, //////预订成功
        // 表单元素
        form: {
          userName: '',
          cardType: '',
          cardNo: '',
          email: '',
          smsCode: '',
          valideCode:"",
          tel:"",
          bookDate:null,
        },
        // 表单规则
        rules2: {
          userName: [
            {required: true, message: "The real name cannot be empty", trigger: "blur"}
          ],
          cardType: [
            {required: true, message: "The ID type cannot be empty", trigger: ["blur", "change"]}
          ],
          cardNo: [
            {required: true, message: "The ID number cannot be empty", trigger: "blur"}
          ],
          email: [
            { required: true, message: "The email address cannot be empty", trigger: "blur" },
            { type: "email",message: "Please enter the correct email address", trigger: ["blur", "change"]}
          ],
          smsCode: [
            {required: true, message: "The verification code cannot be empty", trigger: "blur"}
          ],
          bookDate: [
            {required: true, message: "Time cannot be empty", trigger: "blur"}
          ],
        },
        rules: {
          userName: [
            {required: true, message: "真实姓名不能为空", trigger: "blur"}
          ],
          cardType: [
            {required: true, message: "证件类型不能为空",trigger: ["blur", "change"]}
          ],
          cardNo: [
            {required: true, message: "证件号码不能为空", trigger: "blur"}
          ],
          email: [
            { required: true, message: "邮箱地址不能为空", trigger: "blur" },
            { type: "email",message: "请输入正确的邮箱地址", trigger: ["blur", "change"]}
          ],
          smsCode: [
            {required: true, message: "验证码不能为空", trigger: "blur"}
          ],
          bookDate: [
            {required: true, message: "时间不能为空", trigger: "blur"}
          ],
        },
        secretCode:"",/////安全码

        imageUrl: require('@/assets/images/Home63@2x.png'),
        imageUrl2: require('@/assets/images/Home63_2@2x.png')
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.toReset()
        // 获取展厅
        this.getListShowRoom()
        // 获取藏品
        this.getGoodsType()
        // 获取冠军故事
        this.getData()
        // 获取举重新闻
        this.getNewsData('举重新闻')
      }
    },
    created(){
      this.toReset()
      // 获取展厅
      this.getListShowRoom()
      // 获取藏品
      this.getGoodsType()
      // 获取冠军故事
      this.getData()
      // 获取举重新闻
      this.getNewsData('举重新闻')

      this.getSecretCode();
    },
    methods:{
      // 获取展厅
      async getListShowRoom(val) {
        let params = {
          pageNum: 1,
          pageSize: 9,
          orderByColumn: "sort_num",
          isAsc: "ascending"  // : "descending"  "ascending"
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await listShowRoom(params)
        rows.forEach((val)=>{
          let arr = val.webPicUrl?val.webPicUrl.split(','):[]
          this.part5Arr.push({
            id : val.id,
            title : this.$store.getters.lang == 'zh'?val.showTitle:val.showTitleEn,
            picUrl : this.$store.getters.urlApi + val.webMainPic,
            summary : this.$store.getters.lang == 'zh'?val.webTextMemo:val.webTextMemoEn,
            picLeft : this.$store.getters.urlApi + arr[0],
            picright : this.$store.getters.urlApi + arr[1],
            picright2 : this.$store.getters.urlApi + arr[2],
            picright3 : this.$store.getters.urlApi + arr[3],
          })
        })
        // 初始化
        this.toInit()
      },
      // 获取冠军故事
      async getData(val) {
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "首页冠军故事",
          articleKey:"cms",
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)
        rows.forEach(val => {
          let arr = val.smallTitle?val.smallTitle.split('|'):[]
          let arr2 = val.faceThum?val.faceThum.split(','):[]
          this.part4Arr.push({
            id : val.id,
            picLeft : this.$store.getters.urlApi + val.faceUrl,
            picRight : this.$store.getters.urlApi + arr2[0],
            name : arr[0],
            title : arr[1],
            summary : val.bigTitle
          })
        })
        // 初始化
        this.toInit()
      },
      // 获取藏品
      async getGoodsType() {
        let  lang = this.$store.getters.lang
        let {data:{data}} = await getGoodsTypeVer2({ lang })
        console.log("获取藏品");
        console.log(data);
        // 处理第一层
        data.forEach((val)=>{
          this.part6Arr.push({
            title : val.title,
            icon : this.$store.getters.urlApi + val.icon,
            listData : []
          })
        })
        // 处理第二层
        data.forEach((val,index)=>{
          let arr = []
          val.listData.forEach((val2,index2)=>{
            let goodsType =  this.$store.getters.lang == 'en'?val2.goodsTypeEn:val2.goodsType
            if(val.title == goodsType){
              arr.push({
                id : val2.id,
                summary: this.$store.getters.lang == 'zh' ? val2.webTextMemo : val2.webTextMemoEn,
                pic: this.$store.getters.urlApi + val2.webMainPic,
              })
            }
          })
          this.$set(this.part6Arr[index],'listData',arr)
        })
        // 初始化
        this.toInit()
      },
      // 获取新闻
      async getNewsData(val) {
        let params = {
          pageNum: 1,
          pageSize: 3,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: val,
          articleKey:"cms",
        }
        let {data:{rows}} = await getSingle(params)
         // console.log(rows);
        let imageUrl = val == '通知公告' ? this.imageUrl : this.imageUrl2
        rows.forEach(val=>{
          this.part7Arr.push({
            id : val.id,
            title : val.smallTitle,
            summary : val.bigTitle,
            picUrl : val.faceUrl == null || val.faceUrl == '' ? imageUrl : this.$store.getters.urlApi + val.faceUrl ,
            addTime : this.parseTime(new Date(val.updateTime),"{y}-{m}-{d} {h}:{i}"),
          })
        })

        // 初始化
        this.toInit()
      },
      // 重置变量
      toReset(){
        this.part4Arr = []
        this.part5Arr = []
        this.part6Arr = []
        this.part7Arr = []
      },
      // 初始化
      toInit(){
        this.$nextTick(() => {
          new Swiper('.mySwiper', {
            // loop: true,  // 循环video有问题
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              //点击小球的时候也切换图片
              clickable: true,
              // type : 'bullets',
              type: "progressbar",
            },
            autoplay: {
              delay: 6000,
              disableOnInteraction: false //加这句
            },
            // 如果需要导航按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
              slideChangeTransitionStart:function () {
                this.$(".animation1").removeClass("anim1")
                this.$(".animation1en").removeClass("anim1en")
                this.$(".animation2").removeClass("anim2")
                this.$(".animation3").removeClass("anim3")
                this.$(".animation4").removeClass("anim4")
                this.$(".animation5").removeClass("anim5")
              },
              slideChangeTransitionEnd: function () {
                setTimeout(()=>{
                  this.$(".animation1").addClass("anim1")
                  this.$(".animation1en").addClass("anim1en")
                  this.$(".animation2").addClass("anim2")
                  this.$(".animation3").addClass("anim3")
                  this.$(".animation4").addClass("anim4")
                  this.$(".animation5").addClass("anim5")
                },20)
              },
            }
          });

          this.scaleBiLi = document.documentElement.clientWidth / 1920
          window.addEventListener('resize',()=>{
            this.scaleBiLi = document.documentElement.clientWidth / 1920
          })

          // 获取元素到顶部的距离
          setTimeout(()=>{
            var offsetTopPart4 = this.$('.part4').offset().top;
            var offsetTopPart3 = this.$('.part3').offset().top;
            var offsetTopPart5 = this.$('.part5').offset().top;
            var offsetTopPart6 = this.$('.part6').offset().top;
            var offsetTopPart7 = this.$('.part7').offset().top;

            window.addEventListener('scroll', ()=> {
              var scrollPositionFromTop = window.scrollY; // 获取当前滚动位置
              if (scrollPositionFromTop >= offsetTopPart4*this.scaleBiLi) {
                // 滚动到元素时执行动画
                this.$(".animation6").addClass("anim6")
                this.$(".animation7").addClass("anim7")
              }else{
                this.$(".animation6").removeClass("anim6")
                this.$(".animation7").removeClass("anim7")
              }

              if (scrollPositionFromTop >= offsetTopPart3*this.scaleBiLi) {
                // 滚动到元素时执行动画
                this.$(".animation8").addClass("anim8")
                this.$(".animation9").addClass("anim9")
                this.$(".animation10").addClass("anim10")
              }else{
                this.$(".animation8").removeClass("anim8")
                this.$(".animation9").removeClass("anim9")
                this.$(".animation10").removeClass("anim10")
              }

              if (scrollPositionFromTop >= offsetTopPart5*this.scaleBiLi) {
                // 滚动到元素时执行动画
                this.$(".animation11").addClass("anim11")
                this.$(".animation12").addClass("anim12")
                this.$(".animation13").addClass("anim13")
                this.$(".animation14").addClass("anim14")
              }else{
                this.$(".animation11").removeClass("anim11")
                this.$(".animation12").removeClass("anim12")
                this.$(".animation13").removeClass("anim13")
                this.$(".animation14").removeClass("anim14")
              }

              if (scrollPositionFromTop >= offsetTopPart6*this.scaleBiLi) {
                // 滚动到元素时执行动画
                if(document.querySelector('.animation15')){
                  this.$(".animation15").addClass("anim15")
                }
                if(document.querySelector('.animation16')){
                  this.$(".animation16").addClass("anim16")
                }
                if(document.querySelector('.animation17')){
                  this.$(".animation17").addClass("anim17")
                }
                if(document.querySelector('.animation18')){
                  this.$(".animation18").addClass("anim18")
                }
              }else{
                if(document.querySelector('.animation15')){
                  this.$(".animation15").removeClass("anim15")
                }
                if(document.querySelector('.animation16')){
                  this.$(".animation16").removeClass("anim16")
                }
                if(document.querySelector('.animation17')){
                  this.$(".animation17").removeClass("anim17")
                }
                if(document.querySelector('.animation18')){
                  this.$(".animation18").removeClass("anim18")
                }
              }
              // if (scrollPositionFromTop >= offsetTopPart7*this.scaleBiLi) {
              //   // 滚动到元素时执行动画
              //   this.$(".animation19").addClass("anim19")
              //   this.$(".animation20").addClass("anim20")
              // }else{
              //   this.$(".animation19").removeClass("anim19")
              //   this.$(".animation20").removeClass("anim20")
              // }
            });
          },20)


        });
      },
      // 切换语言
      toChangeLang(val){
        i18n.locale = val  // 改变为英文
        localStorage.setItem('lang',val) //在localStorage中存入设置
        this.$store.dispatch('GetLang', val)
        // let message = '已切换成：' + (val=='en'?'EN英文版':'CN中文版')
        // this.$message({
        //   message,
        //   type: 'success'
        // });
      },
      // 搜索
      toKeyDownEnter(){
        this.$router.push({path:'/Search',query: {keyword:this.keyword}})
      },
      // 视频
      toOpenMP4() {
        window.open('https://www.cwmuseum.cn/img/aaa.mp4', '_blank');
      },
      toPart4Prev(){
        if(this.part4ArrIndex==0) return
        this.part4ArrIndex--
      },
      toPart4Next(){
        if(this.part4ArrIndex==this.part4Arr.length-1) return
        this.part4ArrIndex++
      },
      toPart5Tab(index){
        this.part5Index = index
      },
      toPart5Prev(){
        if(this.part5Index==0) return
        this.part5Index--
      },
      toPart5Next(){
        if(this.part5Index==this.part5Arr.length-1) return
        this.part5Index++
      },
      toPart6Tab(index){
        this.part6Index = index
        // 初始化
        if(document.querySelector('.animation16')){
          this.$(".animation16").removeClass("anim16")
        }
        if(document.querySelector('.animation17')){
          this.$(".animation17").removeClass("anim17")
        }
        if(document.querySelector('.animation18')){
          this.$(".animation18").removeClass("anim18")
        }

        setTimeout(()=>{
          if(document.querySelector('.animation16')){
            this.$(".animation16").addClass("anim16")
          }
          if(document.querySelector('.animation17')){
            this.$(".animation17").addClass("anim17")
          }
          if(document.querySelector('.animation18')){
            this.$(".animation18").addClass("anim18")
          }
        },20)



      },
      toPart7Tab(index){
        this.part7Index = index

        this.part7Arr = []
        if(index == 0){
          this.getNewsData('举重新闻')
        }else if(index ==1){
          this.getNewsData('通知公告')
        }else if(index ==2){
          this.getNewsData('资讯动态')
        }
      },

      async getSecretCode(){
        let _res = await getTokenCode( );
        this.secretCode=_res.data.msg;
        this.form.valideCode=_res.data.msg;
      },

      // 海外观众预约（邮箱、短信）
      toTanGuoWai() {
        this.dialogVisible_GuoWai = true
      },
      // 二维码预约
      toTanWeiXin() {
        this.dialogVisible_WeiXin = true
      },
      // 关闭弹窗
      toHideDialog() {
        this.form = {
          userName: '',
          cardType: '',
          cardNo: '',
          email: '',
          smsCode: '',
          valideCode:"",
          tel:"",
          bookDate:null,
        }
        this.$refs['form'].clearValidate()
        this.dialogVisible_WeiXin = false
        this.dialogVisible_GuoWai = false
        this.dialogVisible_GuoWai_BookSuccess=false;
      },
      // 提交表单
      toSubmit() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            bookingByEmailValidCode(this.form).then(response => {
              // console.log("bookingByEmailValidCode:",response)
              if (response.data.msg=="ok"){
                if(this.$store.getters.lang == 'en'){
                  this.$message({
                    message: 'Booking is successful! Booking information has been sent to you in the mail',
                    type: 'success'
                  });
                }else{
                  this.$message({
                    message: '预订成功！预订信息已发送到您的邮件中',
                    type: 'success'
                  });
                }

                this.dialogVisible_GuoWai_BookSuccess=true;
              }else {
                this.$message.error(response.data.msg);
              }

            });
          }
        });
      },
      toGetValidCode(){

        this.$refs["form"].validateField('email', valid => {
          if(valid=="") {
            if (this.form.email==null || this.form.email==""){
              if(this.$store.getters.lang == 'en'){
                this.$message.error('The email address cannot be empty');
              }else{
                this.$message.error('邮箱地址不能为空');
              }
              return false;
            }
            getEmailValidCode(this.form).then(response => {
              // console.log("get:",response)
              if (response.data.msg=="ok"){
                if(this.$store.getters.lang == 'en'){
                  this.$message({
                    message: 'The verification code has been sent to your email',
                    type: 'success'
                  });
                }else{
                  this.$message({
                    message: '验证码已经发到了您的电子邮箱中',
                    type: 'success'
                  });
                }
              }else {
                this.$message.error(response.data.msg);
              }

            });

          }
        })


      }
    }
  }
</script>

<style lang="less">
  /* 视频 */
  .video{
    cursor: pointer;
    position: absolute;
    right: 84px;
    bottom: 242px;
    z-index: 10;
    width:362px;
    height:182px;
    opacity: 0;
    img.playerBtn{
      position: absolute;
      left: 50%;
      top: 49.5%;
      transform: translate(-50%,-50%);
    }
  }
  /* 分页器 */
  .mySwiper-pagination{
    position: absolute;
    bottom: 5%;
    left: 72%;
    height: 30px;
    background: transparent;
    z-index: 1;
    display: flex;
    align-items: center;
    width: 210px;
    font-size: 24px;
    color: #333333;
    line-height: 23px;
    .middle{
      flex: 0 0 128px;
      margin: 0 13px;
      height: 30px;
      display: flex;
      align-items: center;
        .swiper-pagination-progressbar{
          height: 2px;
          width: calc(100% - 82px);
          .swiper-pagination-progressbar-fill{
            background: #DA1E2D !important;
            height: 4px;
            top: -1px;
          }
        }
    }
  }
  /* Banner动画 */
  .anim1{animation: anim1 2s forwards}
  .anim1en{animation: anim1en 2s forwards}
  .anim2{animation: anim2 2s forwards}
  .anim3{animation: anim3 2s forwards}
  .anim4{animation: anim4 2s forwards}
  .anim5{animation: anim5 2s forwards}
  @keyframes anim1 {
    0% {left : 0;}
    to {left: 7.2%}
  }
  @keyframes anim1en {
    0% {left : 0;}
    to {left: 9.8%}
  }
  @keyframes anim2 {
    0% {right : 0;}
    to {right: 11.4%;}
  }
  @keyframes anim3 {
    0% {left : -16.7%;}
    to {left: -11%;}
  }
  @keyframes anim4 {
    0% {right : -11.7%;}
    to {right: 0;}
  }
  @keyframes anim5 {
    0% {right : -362px;opacity: 0}
    to {right: 84px;opacity: 1}
  }
  // Part4 动画
  .anim6{animation: anim6 2s forwards}
  .anim7{animation: anim7 2s forwards;animation-delay: 0.5s;}
  @keyframes anim6 {
    0% {left : -1040px;opacity: 0}
    to {left: 0;opacity: 1}
  }
  @keyframes anim7 {
    0% {left : -420px;opacity: 0}
    to {left: 302px;opacity: 1}
  }
  // Part3 动画
  .anim8{animation: anim8 2s forwards}
  .anim9{animation: anim9 2s forwards;animation-delay: 0.5s;}
  .anim10{animation: anim10 1s forwards;animation-delay: 1.5s;}
  @keyframes anim8 {
    0% {right : -334px;opacity: 0}
    to {right: 787px;opacity: 1}
  }
  @keyframes anim9 {
    0% {right : -1048px;opacity: 0}
    to {right: 0;opacity: 1}
  }
  @keyframes anim10 {
    0% {right : -230px;opacity: 0}
    to {right: 0;opacity: 1}
  }
  // Part5 动画
  .anim11{animation: anim11 2s forwards}
  .anim12{animation: anim12 2s forwards;animation-delay: 0.5s;}
  .anim13{animation: anim13 1.5s forwards;animation-delay: 1s;}
  .anim14{animation: anim14 1.5s forwards;animation-delay: 1.5s;}
  @keyframes anim11 {
    0% {right : -284px;opacity: 0}
    to {right: 776px;opacity: 1}
  }
  @keyframes anim12 {
    0% {right : -1048px;opacity: 0}
    to {right: 0;opacity: 1}
  }
  @keyframes anim13 {
    0% {right : -288px;opacity: 0}
    to {right: 0;opacity: 1}
  }
  @keyframes anim14 {
    0% {right : -156px;opacity: 0}
    to {right: 0;opacity: 1}
  }
  // Part6 动画
  .anim15{animation: anim15 1.6s forwards}
  .anim16{animation: anim16 1.6s forwards;animation-delay: 0.5s;}
  .anim17{animation: anim17 0.8s forwards;animation-delay: 1s;}
  .anim18{animation: anim18 0.8s forwards;animation-delay: 1.5s;}
  @keyframes anim15 {
    0% {left : 1748px;opacity: 0}
    to {left: 0;opacity: 1}
  }
  @keyframes anim16 {
    0% {left : 1748px;opacity: 0}
    to {left: 313px;opacity: 1}
  }
  @keyframes anim17 {
    0% {left : 1748px;opacity: 0}
    to {left: 705px;opacity: 1}
  }
  @keyframes anim18 {
    0% {left : 1748px;opacity: 0}
    to {left: 1024px;opacity: 1}
  }
  // Part7 动画
  .anim19{animation: anim19 1.5s forwards;animation-delay: 0.5s;}
  .anim20{animation: anim20 1.5s forwards;}
  @keyframes anim19 {
    0% {left : -980px;opacity: 0}
    to {left: 0;opacity: 1}
  }
  @keyframes anim20 {
    0% {left : -954px;opacity: 0}
    to {left: 161px;opacity: 1}
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  /* 轮播css */
  .swiper {width:100%;}
  .swiper-slide {overflow:hidden}
  /* 导航按钮 */
  .mySwiper-button {width:100px;position:absolute;right:3.6%;bottom:5%;height:30px;}
  .swiper-button-next:after,.swiper-button-prev:after {font-size:18px !important;color: #fff !important;}
  .swiper-button-next {width:30px !important;height:30px !important;background:#333333;top:0 !important;right:0 !important;bottom:0 !important;margin:0 !important;}
  .swiper-button-next:hover,.swiper-button-prev:hover {background:#DA1E2D;}
  .swiper-button-prev {width:30px !important;height:30px !important;background:#333333;top:0 !important;left:0 !important;bottom:0 !important;margin:0 !important;}

  /* 轮播图css */
  .part1{
    position: relative;
    .switchBtn{
      z-index: 1;
      position: absolute;
      right: 60px;
      top: 45px;
      display: flex;
      align-items: center;
      .item{
        border-radius: 50%;
        background: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .item:nth-of-type(1){
        padding: 10px 9px 9px 10px;
      }
      .item:nth-of-type(2){
        padding: 10px 6px 10px 7px;
      }
      .item:nth-of-type(3){
        padding: 8px 14px;
        border-radius: 17px;
        margin-left: 30px;
      }
      i{
        width: 2px;
        height: 27px;
        background: #ECECEC;
        margin: 0 20px;
      }
    }
    .navigation{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      height: 152px;
      .navigation-cover{
        display: flex;
        height: 100%;
      }
      .item{
        font-weight: bold;
        height: 100%;
        font-size: 24px;
        color: #FFFFFF;
        /*flex: 0 0 137px;*/
        flex: 0 0 152px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 100%;
      }
      .item:hover{
        background:url("https://www.cwmuseum.cn/img/Home12@2x.png") no-repeat center 76%;
      }
      .item.active{
        background:url("https://www.cwmuseum.cn/img/Home12@2x.png") no-repeat center 76%;
      }
    }
  }
  /* 服务部分css */
  .part2{
    width: 100%;
    height: 631px;
    background: url("https://www.cwmuseum.cn/img/Home13@2x.png") no-repeat top right #F6F6F6;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .main{
      display: flex;
      .item{
        width: 345px;
        height: 332px;
        background-size: cover;
        padding-left: 32px;
        &:nth-child(1){
          background: url("https://www.cwmuseum.cn/img/Home14@2x.png") no-repeat;
        }
        &:nth-child(2){
          background: url("https://www.cwmuseum.cn/img/Home16@2x.png") no-repeat;
          background-size: cover;
        }
        &:nth-child(3){
          background: url("https://www.cwmuseum.cn/img/Home18@2x.png") no-repeat;
        }
        &:nth-child(4){
          background: url("https://www.cwmuseum.cn/img/Home20@2x.png") no-repeat;
          background-size: cover;
        }
        &.item1{
          .p1{
            margin-top: 36px;
          }
          .p2{
            font-family: "Source Han Sans CN";
            font-weight: bold;
            font-size: 24px;
            color: #222222;
            line-height: 1;
            margin-top: 23px;
            margin-bottom: 15px;
          }
          .p3{
            font-family: "Source Han Sans CN";
            font-size: 18px;
            color: #222222;
            line-height: 28px;
          }
          .p4{
            font-family: Source Han Sans CN;
            font-size: 16px;
            color: #555555;
            line-height: 22px;
            margin-top: 21px;
            width: 271px;
            text-align: justify;
          }
        }
        &.item2{
          .p1{
            margin-top: 36px;
          }
          .p2{
            font-family: "Source Han Sans CN";
            font-weight: bold;
            font-size: 24px;
            color: #fff;
            line-height: 1;
            margin-top: 23px;
            margin-bottom: 39px;
          }
          .p3{
            display: flex;
            .p3-item{
              width: 118px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #FFFFFF;
              cursor: pointer;
              transition: .3s;
              &:nth-child(2){
                margin-left: 36px;
              }
              &:hover{
                background: #DA1E2D;
                color: #FFFFFF;
              }
            }
          }
          .p4{
            font-family: Source Han Sans CN;
            font-size: 16px;
            color: #fff;
            line-height: 24px;
            margin-top: 34px;
            width: 288px;
            text-align: justify;
          }
        }
        &.item3{
          .p1{
            margin-top: 36px;
          }
          .p2{
            font-family: "Source Han Sans CN";
            font-weight: bold;
            font-size: 24px;
            color: #222222;
            line-height: 1;
            margin-top: 23px;
            margin-bottom: 17px;
          }
          .p3{
            width: 266px;
            height: 131px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            color: #222222;
            line-height: 28px;
            text-align: justify;
            .p3-item{
              display: flex;
              .p3-item-l{
                flex: 0 0 54px
              }
            }
          }
        }
        &.item4{
          .p1{
            margin-top: 36px;
          }
          .p2{
            font-family: "Source Han Sans CN";
            font-weight: bold;
            font-size: 24px;
            color: #fff;
            line-height: 1;
            margin-top: 23px;
            margin-bottom: 18px;
          }
          .p3{
            display: flex;
            flex-direction: column;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 28px;
            .p3-item{
              display: flex;
              align-items: center;
              .p3-item-l{
                width: 12px;
                height: 12px;
                border: 2px solid #fff;
                border-radius: 50%;
                margin-right: 16px;
              }
            }
          }

        }
      }
    }
  }
  /* 举重简介css */
  .part3{
    width: 100%;
    height: 1119px;
    position: relative;
    overflow: hidden;
    padding-top: 178px;
    padding-left: 86px;
    .text{
      width: 756px;
      height: 600px;
      background: url("https://www.cwmuseum.cn/img/Home22@2x.png") no-repeat left top;
      padding-left: 185px;
      .title{
        margin-top: 38px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 40px;
        color: #222222;
        line-height: 1;
      }
      .summary{
        text-indent: 2em;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        line-height: 42px;
        text-align: justify;
        margin-top: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        overflow: hidden;
      }
      .feature{
        margin-top: 58px;
        width: 530px;
        display: flex;
        margin-bottom: 78px;
        .item{
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          &:first-child::after{
            display: none;
          }
          &::after{
            content: "";
            width: 2px;
            height: 39px;
            background: #C8C8C8;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          .theme{
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 18px;
            color: #222222;
            line-height: 1;
            margin-top: 13px;
          }
          .summarize{
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #555555;
            line-height: 18px;
            margin-top: 10px;
            text-align: center;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
      .more{
        cursor: pointer;
      }
    }
    .banner{
      width: 1119px;
      height: 759px;
      position: absolute;
      top: 180px;
      right: 0;
      .pic01{
        position: absolute;
        right: -334px;
        top:150px;
      }
      .pic02{
        position: absolute;
        right: -1048px;
        top:0;
      }
      .pic03{
        position: absolute;
        right: -230px;
        bottom: 0;
      }

    }
  }
  /* 藏品部分css */
  .part4{
    width: 100%;
    height: 1260px;
    padding-top: 89px;
    background: #f6f6f6;
    overflow: hidden;
    position: relative;
    .banner{
      width: 1038px;
      height: 872px;
      position: relative;
      img.img01{
        position: absolute;
        bottom: 0;
        left: -1040px;
        width: 1038px;
        height: 872px;
      }
      .more{
        position: absolute;
        bottom: 0;
        left: -420px;
        cursor: pointer;
        width: 419px;
        height: 100px;
      }
    }
    .text{
      position: absolute;
      width: 615px;
      height:888px;
      top: 223px;
      right: 262px;
      .name{
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 36px;
        color: #222222;
        text-align: right;
      }
      .title{
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        text-align: right;
        font-size: 46px;
        margin-top: 36px;
        padding-left: 37px;
        line-height: 1.25;
      }
      .summary{
        display: flex;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        line-height: 40px;
        margin-top: 8px;
        min-height: 220px;
        background: url("https://www.cwmuseum.cn/img/Home33@2x.png") no-repeat left top;
        padding-top: 24px;
        padding-left: 52px;
      }
      .btn{
        display: flex;
        align-items: flex-end;
        justify-content: end;
        position: relative;
        top: -6px;
        cursor: pointer;
      }
      .pic{
        cursor: pointer;
        width: 468px;
        height: 368px;
        position: absolute;
        bottom: 0;
        right: -60px;
        .picBox{
          position: relative;
          width: 100%;
          height: 100%;
          img {
            cursor: pointer;
            &:nth-child(2) {
              position: absolute;
              left: 0;
              top: 0;
            }
            &:nth-child(1) {
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
        }
      }
    }
  }
  /* 展厅介绍css */
  .part5{
    .tab{
      width: 100%;
      height: 375px;
      overflow:hidden;
      padding-top : 180px;
      .list{
        display: flex;
        justify-content: center;
        .item{
          flex: 0 0 222px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .pic{
            width: 90px;
            height: 90px;
            position: relative;
            img{
              width: 90px;
              height: 90px;
              border-radius: 45px;
              filter: grayscale(1);
            }
          }

          &:hover img{
            border:4px solid #DA1E2D;
            transition: .1s;
            filter: grayscale(0);
          }
          &.active img{
            border:4px solid #DA1E2D;
            transition: .1s;
            filter: grayscale(0);
          }
          &.active .title::after{
            display: block;
          }
          &:hover .title::after{
            display: block;
          }

          .title{
            font-family: Source Han Sans CN;
            font-size: 22px;
            color: #222222;
            margin-top: 20px;
            padding-bottom: 63px;
            position: relative;
            width: 207px;
            text-align: center;
            &::after{
              display: none;
              position: absolute;
              bottom: 30px;
              left: 50%;
              transform: translateX(-50%);
              content: "";
              width: 0;
              height: 0;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-top: 8px solid black;
            }
          }
        }
      }
    }

    .main{
      position: relative;
      width: 1473px;
      height: 1180px;
      .content{
        width: 100%;
        height: 100%;
        position: relative;
        .bgLine{
          position: absolute;
          left: 46px;
          top: -69px;
        }
        .text{
          width: 640px;
          position: absolute;
          top: 212px;
          left: 269px;
          text-align: justify;
          .title{
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 40px;
            color: #FFFFFF;
          }
          .summary{
            margin-top: 41px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 22px;
            height: 446px;
            margin-bottom: 40px;
            color: #FFFFFF;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 11;
            overflow: hidden;
          }
          .btn{
            img{
              cursor: pointer;
            }
            .next{
              margin-left: 40px;
            }
          }
        }

      }
      .banner{
        width: 1069px;
        height: 1073px;
        position: absolute;
        top: 107px;
        right: 0;
        cursor: pointer;
        .pic-cover{
          width: 100%;
          height: 100%;
          .pic01{
            position: absolute;
            top: 266px;
            right: -282px;
          }
          .pic02{
            position: absolute;
            top: 0;
            right: -1048px;
          }
          .pic03{
            position: absolute;
            top: 669px;
            right: -156px;
          }
          .pic04{
            position: absolute;
            top: 553px;
            right: -288px;
          }
        }

      }
    }
  }
  /* 举博藏品css */
  .part6{
    width: 100%;
    height: 1326px;
    background: url("https://www.cwmuseum.cn/img/Home52@2x.png") top right  no-repeat;
    background-size: contain;
    overflow: hidden;
    padding-top: 211px;
    padding-left: 174px;
    .main{
      width: 1571px;
      height: 606px;
      position: relative;
      .conItem{
        cursor: pointer;
        .img-cover{
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          cursor: pointer;
        }
        &:nth-child(1){
          width: 540px;
          height: 486px;
          padding-top: 62px;
          padding-left: 211px;
          background: url("https://www.cwmuseum.cn/img/Home53@2x.png") no-repeat;
          .title{
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 40px;
            color: #FFFFFF;
          }
          .number{
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 22px;
            color: #FFFFFF;
            margin-top: 40px;
            span{
              font-family: Microsoft Yahei;
              font-size: 59px;
              color: #FFFFFF;
              line-height: 1;
              margin-right: 16px;
              letter-spacing: -4px;
              font-weight: 600;
            }
          }
          .list{
            margin-top: 55px;
            position: relative;
            left: -10px;
            .item{
              opacity: .6;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 22px;
              color: #FFFFFF;
              padding-left: 22px;
              display: flex;
              align-items: center;
              cursor: pointer;
              transition: .3s;
              span{
                margin-left: 13px;
              }
              & + .item{
                margin-top: 40px;
              }
              &.active, &:hover{
                opacity: 1;
                background: url("https://www.cwmuseum.cn/img/Home54@2x.png") no-repeat center left;
              }
            }
          }
        }
        &:nth-child(1){
          position: absolute;
          left: -1748px;
          top: 0;
        }
        &:nth-child(2){
          position: absolute;
          top: 55px;
          left: -1748px;
          z-index: 1;
          .item-text{
            position: absolute;
            bottom: 28px;
            left: 73px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 30px;
            width: 293px;
            text-align: justify;
            height: 120px;
            isplay: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;
          }
        }
        &:nth-child(3){
          position: absolute;
          top: -51px;
          left: -1748px;
          .item-text{
            position: absolute;
            bottom: 28px;
            left: 73px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 30px;
            width: 293px;
            text-align: justify;
            height: 120px;
            isplay: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;
          }
        }
        &:nth-child(4){
          position: absolute;
          top: 20px;
          left: -1748px;
          .item-text{
            position: absolute;
            bottom: 28px;
            left: 73px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 30px;
            width: 293px;
            text-align: justify;
            height: 120px;
            display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;
          }
        }
        &:hover{
          .img-cover{
            display: block;
          }
          >div{
            cursor: pointer;
            display: block !important;
          }
        }
      }
    }
  }
  /* 新闻中心css */
  .part7{
    width: 100%;
    height: 1328px;
    background: #f6f6f6;
    position: relative;
    .bgLine{
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .main{
      .banner{
        overflow: hidden;
        position: relative;
        width: 1112px;
        height: 1021px;
        img{
          &:nth-child(1){
            top: 80px;
            /*left: -980px;*/
            position: absolute;
            z-index: 8888;
          }
          &:nth-child(2){
            position: absolute;
            /*left: -954px;*/
            top: 0;
          }
        }
      }
      .new{
        width: 442px;
        position: absolute;
        top: 0;
        left: 1220px;
        .newHot{
          margin-bottom: 52px;
          .title{
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 40px;
            color: #222222;
            padding-top: 72px;
          }
          .summary{
            margin-top: 24px;
            margin-bottom: 17px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 22px;
            color: #222222;
            line-height: 36px;
            /*cursor: pointer;*/
            transition: .3s;
            text-align: justify;
            /*&:hover{*/
              /*color: #DA1E2D;*/
            /*}*/
          }
          .detail{
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 22px;
            color: #555555;
            line-height: 36px;
            text-align: justify;
          }
        }
        .newList{
          .tab{
            display: flex;
            span{
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 22px;
              color: #222222;
              cursor: pointer;
              transition: .3s;
              & + span{
                margin-left: 58px;
              }
              &.active{
                color: #da1e2d;
              }
              &:hover{
                color: #da1e2d;
              }
            }
          }
          .item{
            margin-top: 30px;
            .list{
              display: flex;
              height: 120px;
              cursor: pointer;
              justify-content: space-between;
              & + .list{
                margin-top: 29px;
              }
              &:hover .title{
                color: #DA1E2D !important;
              }
              &:hover .pic img{
                transform: scale(1.1);
              }
              .pic{
                flex: 0 0 110px;
                height: 89px;
                display: flex;
                overflow: hidden;
                img{
                  transition: .3s;
                  width: 100%;
                }
              }
              .text{
                position: relative;
                top: -5px;
                flex: 0 0 315px;
                .title{
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 20px;
                  color: #222222;
                  line-height: 28px;
                  transition: .3s;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                .addTime{
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 18px;
                  color: #999999;
                  line-height: 24px;
                  margin-top: 19px;
                  padding-bottom: 24px;
                  border-bottom: 2px solid #D0D0D0;
                }
              }
            }
          }
          .more{
            cursor: pointer;
            float: right;
            margin-top: 42px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #DA1E2D;
            line-height: 30px;
            display: flex;
            align-items: center;
            img{
              margin-left: 9px;
            }
          }
        }

      }
    }
  }

  /* 弹窗css */
  /deep/ .el-dialog {
    margin-top: 10vh !important;
  }

  .tan_weixin {
    padding-bottom: 80px;

    .title {
      display: block;
      margin: 0 auto 60px;
    }

    .code {
      display: block;
      margin: 0 auto;
      width: 400px;
    }
  }

  .tan_guowai {
    padding-bottom: 20px;

    .title {
      display: block;
      margin: 0 auto 60px;
    }

    .form {
      display: flex;
      padding-left: 50px;

      /deep/ .el-form-item__label {
        font-family: SourceHanSans;
        font-size: 16px;
        color: #DA1E2D;
        padding: 0 20px 0 0;
      }

      /deep/ .el-input__inner {
        font-family: SourceHanSans;
        font-weight: 400;
        font-size: 16px;
        color: #A5ABB7;
        height: 48px;
        background: #F0F2F6;
        border-radius: 5px;
        border: none;
      }

      .el-form-item {
        margin-bottom: 24px;
      }

      .btn {
        border-color: #DA1E2D;
        width: 430px;
        height: 48px;
        background: #DA1E2D;
        border-radius: 5px;
        margin-top: 24px;
      }
    }
  }

  .tan_success {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;

    img:nth-child(1) {
      width: 259px;
    }

    img:nth-child(2) {
      width: 112px;
    }

    .summary {
      width: 528px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #555555;
      line-height: 32px;
      margin-top: 20px;
      text-align: justify;
    }

    .btn {
      width: 168px;
      height: 48px;
      line-height: 48px;
      background: #DA1E2D;
      border-radius: 5px;
      margin: 70px auto 0;
      display: block;
      font-family: SourceHanSans;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue